/* script */
//
//
//
//
//
//
//
//


import ExportBlock from 'ui/components/blocks/ExportBlock.vue';
import AppscriptExportModal from 'shared/ui/components/modals/AppscriptExportModal.vue';
import FpTypeExportModal from 'shared/ui/components/modals/FpTypeExportModal.vue';
/**
 * This component is used to display the short link export screen
 * @exports ShortLinkExport
 */
const __vue_script__ = {
    name: 'ShortLinkExport',

    components: { ExportBlock },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        const options = this.params.currentController?.routeOptions || {};
        return {
            date: this.$utils.time.dateToFormat(this.$utils.time.now(), this.$const.DEFAULT_DATETIME_FORMAT),
            showShortlinkQrExport: options.shortlinkQrExportEnabled
        };
    },


    methods: {
        exportPaxBadgeQrImages() {
            this.$modal.show(AppscriptExportModal, {
                title: this.$t('exports.badge_qr_image.title'),
                jobScript: 'shortlinks/export-pax-badge-qr-images',
                jobOptions: {
                    name: 'Export QR BadgeImages',
                    fileName: `QR-BadgeImages-${this.params.event._id}-${this.date}.zip`
                },
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        exportShortLinkQrImages() {
            this.$modal.show(AppscriptExportModal, {
                title: this.$t('exports.shortlink_qr_image.title'),
                jobScript: 'shortlinks/export-shortlink-qr-images',
                jobOptions: {
                    name: 'Export QR ShortlinkImages',
                    fileName: `QR-ShortlinkImages-${this.params.event._id}-${this.date}.zip`
                },
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        exportShortlinksScans() {
            this.$modal.show(AppscriptExportModal, {
                title: this.$t('exports.qr_image.title'),
                jobScript: 'shortlinks/export-all-scans',
                jobOptions: {
                    name: 'Export QR Shortlink Scans',
                    fileName: `All-Shortlink-Scans-${this.params.event._id}-${this.date}.xlsx`
                },
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        exportPaxQrInfo() {
            this.$modal.show(FpTypeExportModal, {
                title: this.$t('exports.qr_info.title'),
                event: this.params.event,
                icon: 'qr-code',
                exportType: 'qrcode-info',
                fpType: 'person'
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shortlink-export" },
    [
      _c("export-block", {
        attrs: { "export-name": "badge_qr_image" },
        on: { export: _vm.exportPaxBadgeQrImages },
      }),
      _vm.showShortlinkQrExport
        ? _c("export-block", {
            attrs: { "export-name": "shortlink_qr_image" },
            on: { export: _vm.exportShortLinkQrImages },
          })
        : _vm._e(),
      _c("export-block", {
        attrs: { "export-name": "qr_info" },
        on: { export: _vm.exportPaxQrInfo },
      }),
      _c("export-block", {
        attrs: { "export-name": "shortlink_reports" },
        on: { export: _vm.exportShortlinksScans },
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/shortlinks/ShortLinkExport.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__